import React from 'react';
import { motion } from 'framer-motion';
import { LogoGradients } from './LogoGradients';
import {
  RING_ROTATION, RING_TRANSITION, RING_STYLE, NODE_PULSE_ANIMATION, NODES, TEXT_FONT_STYLE,
} from './logoMotion';

export const LogoIcon = () => (
  <svg viewBox="0 0 64 64" className="relative w-16 h-16 drop-shadow-2xl" fill="none">
    <circle cx="32" cy="32" r="30" fill="url(#bgGrad)" opacity="0.15" />
    <motion.circle
      cx="32"
      cy="32"
      r="28"
      stroke="url(#ringGrad)"
      strokeWidth="2.5"
      fill="none"
      strokeDasharray="12 6"
      animate={RING_ROTATION}
      transition={RING_TRANSITION}
      style={RING_STYLE}
    />
    <text x="32" y="38" textAnchor="middle" className="font-bold" fontSize="18" fill="url(#textGrad)" style={TEXT_FONT_STYLE}>
      MRK
    </text>
    {NODES.map((node) => (
      <motion.circle
        key={`${node.cx}-${node.cy}`}
        cx={node.cx}
        cy={node.cy}
        r="2.5"
        fill={node.fill}
        animate={NODE_PULSE_ANIMATION}
        transition={node.transition}
      />
    ))}
    <LogoGradients />
  </svg>
);
